module.exports = __webpack_public_path__ + "static/img/2.00bece0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/eng/2.png
// module id = xB5E
// module chunks = 0